window.dataLayer = window.dataLayer || [];
window.dataLayer.push({
  showSupportChat: true,
});
